import { render, staticRenderFns } from "./PDFExpressViewer.vue?vue&type=template&id=332eb3c4&scoped=true"
import script from "./PDFExpressViewer.vue?vue&type=script&lang=js"
export * from "./PDFExpressViewer.vue?vue&type=script&lang=js"
import style0 from "./PDFExpressViewer.vue?vue&type=style&index=0&id=332eb3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332eb3c4",
  null
  
)

export default component.exports